import React from 'react';

import EmployerAbout from 'Components/EmployerAbout';
import Footer from 'Components/Footer';
import Header from 'Components/Header';

export default function ONas() {
  return (
    <>
      <Header />
      <EmployerAbout bg='bg' overlay='dark' />
      <Footer />
    </>
  );
}